import { getToken } from '@optimus-web/common';
import { DropzoneProps } from './types';

type State = 'disabled' | 'error' | 'isDragging' | 'default';
type DropzoneTokenConfig = Record<State, ReturnType<typeof getToken> | 'inherit'>;
type Props = Pick<DropzoneProps, 'error' | 'disabled'> & { isDragging?: boolean };

export const getState = (props: Props) => {
    let state: State = 'default';

    if (props?.disabled) {
        state = 'disabled';
    } else if (props?.error) {
        state = 'error';
    } else if (props?.isDragging) {
        state = 'isDragging';
    }

    return { state };
};

export const getBorderColor = (props: Props) => {
    const borderColorTokens: DropzoneTokenConfig = {
        default: getToken('borderInteractiveSecondaryDefault'),
        disabled: getToken('borderDisabled'),
        error: getToken('borderAlertDanger'),
        isDragging: getToken('borderInteractivePrimaryDefault'),
    };

    const { state } = getState(props);
    return borderColorTokens[state];
};

export const getBackgroundColor = (props: Props) => {
    const backgroundColorTokens: DropzoneTokenConfig = {
        default: 'inherit',
        disabled: getToken('backgroundDisabled'),
        error: 'inherit',
        isDragging: getToken('backgroundInteractiveSecondaryDefault'),
    };

    const { state } = getState(props);
    return backgroundColorTokens[state];
};
